{
    "subHeader" : "התחברות למערכת",
    "header" : "מערכת ניהול גביה ",
    "email": "אימייל",
    "password": "סיסמה",
    "btnSubmit": "התחבר",
    "forgot": "שכחתי סיסמה"
}